import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiScissors, FiUsers, FiStar, FiArrowRight, FiPhone, FiMapPin, FiClock, FiCheck, FiAward } = FiIcons;

const Home = () => {
  const services = [
    { name: 'Professional Haircuts', icon: FiScissors },
    { name: 'Beard Trimming', icon: FiScissors },
    { name: 'Hot Towel Service', icon: FiStar },
    { name: 'Face Treatments', icon: FiUsers }
  ];

  const gallery = [
    'https://i.ibb.co/zWmHhJwx/image-1.jpg',
    'https://i.ibb.co/4wpyrn29/image-2.jpg',
    'https://i.ibb.co/8LyqXkGv/image-3.jpg',
    'https://i.ibb.co/Z6W7fdm7/image-4.jpg',
    'https://i.ibb.co/4ydVWkS/image-5.jpg',
    'https://i.ibb.co/W4fp9cL6/image-6.jpg'
  ];

  const testimonials = [
    {
      name: "Mohammed Al-Fayed",
      role: "Regular Client",
      text: "Best barbershop in Al Barsha! The attention to detail is amazing. Highly recommended for beard trimming."
    },
    {
      name: "James Wilson",
      role: "Business Executive",
      text: "Great atmosphere and professional staff. Found my go-to place in Dubai for a clean cut."
    },
    {
      name: "Rahul Sharma",
      role: "Regular Client",
      text: "Excellent service. The hot towel shave is a must-try. Very clean and hygienic environment."
    }
  ];

  const features = [
    { title: "Expert Stylists", desc: "Highly trained professionals", icon: FiUsers },
    { title: "Premium Products", desc: "Top quality brands only", icon: FiStar },
    { title: "Hygienic", desc: "Sterile tools & environment", icon: FiCheck },
  ];

  return (
    <div className="w-full">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#826046] to-[#6d4d37] text-white py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
              Welcome to <span className="text-yellow-300">Mr. Shaver</span>
            </h1>
            <p className="text-xl sm:text-2xl mb-8 max-w-3xl mx-auto">
              Premium Gents Salon in Dubai - Where Style Meets Excellence
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/services"
                className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-colors duration-300 flex items-center"
              >
                View Services
                <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
              </Link>
              <a
                href="tel:+971501656278"
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#826046] transition-colors duration-300 flex items-center"
              >
                <SafeIcon icon={FiPhone} className="mr-2 w-5 h-5" />
                Call Now
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-[#826046] font-semibold tracking-wide uppercase mb-3">Who We Are</h2>
              <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">Mastering the Art of Grooming</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                At Mr. Shaver Gents Salon, we blend traditional barbering techniques with modern style. Located in the heart of Al Barsha South, we offer a sanctuary for the modern gentleman who values quality, hygiene, and style.
              </p>
              <div className="flex flex-col sm:flex-row gap-6 mb-8">
                <div className="flex items-center">
                  <div className="bg-[#826046] bg-opacity-10 p-3 rounded-full mr-4">
                    <SafeIcon icon={FiClock} className="w-6 h-6 text-[#826046]" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">Open Daily</h4>
                    <p className="text-sm text-gray-600">9:00 AM - 11:00 PM</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="bg-[#826046] bg-opacity-10 p-3 rounded-full mr-4">
                    <SafeIcon icon={FiAward} className="w-6 h-6 text-[#826046]" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900">Expert Staff</h4>
                    <p className="text-sm text-gray-600">Highly Skilled Barbers</p>
                  </div>
                </div>
              </div>
              <Link to="/about" className="text-[#826046] font-semibold hover:text-[#6d4d37] inline-flex items-center transition-colors">
                Learn More About Us <SafeIcon icon={FiArrowRight} className="ml-2" />
              </Link>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
                <img src="https://i.ibb.co/MDQJ9rBq/image-20.jpg" alt="Salon Interior" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl hidden sm:block">
                <div className="flex items-center gap-4">
                  <div className="text-4xl font-bold text-[#826046]">5+</div>
                  <div className="text-gray-600 text-sm font-medium">Years of<br/>Experience</div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Our Premium Services
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Experience the finest grooming services with our expert barbers
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.name}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center p-6 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <div className="bg-[#826046] w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={service.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{service.name}</h3>
                <p className="text-gray-600 text-sm">Professional service with attention to detail</p>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/services"
              className="bg-[#826046] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#6d4d37] transition-colors duration-300 inline-flex items-center"
            >
              View All Services
              <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-[#826046] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            {features.map((feature, index) => (
              <motion.div
                 key={index}
                 initial={{ opacity: 0, y: 20 }}
                 whileInView={{ opacity: 1, y: 0 }}
                 transition={{ duration: 0.6, delay: index * 0.1 }}
                 viewport={{ once: true }}
                 className="p-6"
              >
                <div className="bg-white bg-opacity-20 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-white text-opacity-80">{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Preview */}
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Our Work Gallery
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              See the quality of our work and the satisfaction of our clients
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {gallery.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="aspect-square overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <img
                  src={image}
                  alt={`Gallery ${index + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link
              to="/gallery"
              className="bg-[#826046] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#6d4d37] transition-colors duration-300 inline-flex items-center"
            >
              View Full Gallery
              <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              What Clients Say
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Don't just take our word for it
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((t, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white p-8 rounded-xl shadow-lg relative"
              >
                <div className="text-[#826046] mb-4">
                  {[...Array(5)].map((_, i) => (
                    <SafeIcon key={i} icon={FiStar} className="w-5 h-5 inline-block fill-current" />
                  ))}
                </div>
                <p className="text-gray-600 mb-6 italic">"{t.text}"</p>
                <div>
                  <h4 className="font-bold text-gray-900">{t.name}</h4>
                  <p className="text-sm text-gray-500">{t.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 lg:py-24 bg-[#826046] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">
              Ready for a Fresh Look?
            </h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Book your appointment today and experience the best grooming services in Dubai
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a
                href="tel:+971501656278"
                className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-semibold hover:bg-yellow-400 transition-colors duration-300 flex items-center"
              >
                <SafeIcon icon={FiPhone} className="mr-2 w-5 h-5" />
                Call: +971 50 165 6278
              </a>
              <a
                href="https://maps.app.goo.gl/VdmfWPBpoRV6vnha8"
                target="_blank"
                rel="noopener noreferrer"
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-[#826046] transition-colors duration-300 flex items-center"
              >
                <SafeIcon icon={FiMapPin} className="mr-2 w-5 h-5" />
                Get Directions
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Home;